import { render } from "./GatewaySettingsModal.vue?vue&type=template&id=c38d025c"
import script from "./GatewaySettingsModal.vue?vue&type=script&lang=js"
export * from "./GatewaySettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script